/**
 * Hide products from online store based on metafield "hide_from_online_store"
 * Redirects from product pages if product should be hidden
 */

(function() {
  'use strict';

  // Get shop all page URL (collections/all)
  function getShopAllUrl() {
    // Try to get from Shopify routes object if available
    if (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.rootUrl) {
      return Shopify.routes.rootUrl + '/collections/all';
    }
    // Fallback to relative URL
    return '/collections/all';
  }

  // Check if current page is a product page
  function isProductPage() {
    return document.body.classList.contains('template-product') || 
           window.location.pathname.includes('/products/');
  }

  // Check if currently in Shopify theme customizer
  function isInCustomizer() {
    return (
      (typeof Shopify !== 'undefined' && Shopify.designMode) ||
      window.location.search.includes('preview_theme_id=') ||
      document.body.classList.contains('shopify-design-mode') ||
      (window.parent && window.parent.Shopify && window.parent.Shopify.designMode)
    );
  }

  // Hide products from grids
  function hideProductsFromGrids() {
    // Do not hide products if in customizer
    if (isInCustomizer()) {
      return;
    }

    // Find all product grid items with the hide attribute
    const hiddenProducts = document.querySelectorAll('[data-hide-from-store="true"]');
    
    hiddenProducts.forEach(function(product) {
      // Hide the product element with multiple methods
      product.style.display = 'none';
      product.style.visibility = 'hidden';
      product.style.height = '0';
      product.style.overflow = 'hidden';
      product.setAttribute('aria-hidden', 'true');
      
      // For predictive search items, also hide parent if needed
      if (product.classList.contains('predictive-search__item') || 
          product.classList.contains('predictive-search__product')) {
        const parentItem = product.closest('.predictive-search__item');
        if (parentItem) {
          parentItem.style.display = 'none';
          parentItem.style.visibility = 'hidden';
          parentItem.style.height = '0';
          parentItem.style.overflow = 'hidden';
        }
      }
    });

    // Also hide products by checking product links
    const productLinks = document.querySelectorAll('a[href*="/products/"]');
    productLinks.forEach(function(link) {
      const productItem = link.closest('.product-grid-item, [data-product-block], .ai-product-card, .product-item, .predictive-search__item');
      if (productItem && productItem.hasAttribute('data-hide-from-store')) {
        productItem.style.display = 'none';
        productItem.style.visibility = 'hidden';
        productItem.style.height = '0';
        productItem.style.overflow = 'hidden';
        productItem.setAttribute('aria-hidden', 'true');
      }
      
      // Also check if the link itself has the attribute
      if (link.hasAttribute('data-hide-from-store')) {
        const parentItem = link.closest('.predictive-search__item');
        if (parentItem) {
          parentItem.style.display = 'none';
          parentItem.style.visibility = 'hidden';
          parentItem.style.height = '0';
          parentItem.style.overflow = 'hidden';
        }
      }
    });
  }

  // Redirect from product page if product should be hidden
  function redirectIfHidden() {
    // Do not redirect if in customizer
    if (isInCustomizer()) {
      return;
    }

    if (!isProductPage()) {
      return;
    }

    // Check if product section has the hide attribute (set by Liquid)
    const productSection = document.querySelector('[data-section-type="product-template"]');
    if (productSection && productSection.hasAttribute('data-hide-from-store')) {
      window.location.href = getShopAllUrl();
      return;
    }

    // Also check for any product block with the attribute
    const productBlock = document.querySelector('[data-product-block][data-hide-from-store="true"]');
    if (productBlock) {
      window.location.href = getShopAllUrl();
      return;
    }

    // Check if body or html has the attribute (fallback)
    if (document.body.hasAttribute('data-hide-from-store') || 
        document.documentElement.hasAttribute('data-hide-from-store')) {
      window.location.href = getShopAllUrl();
      return;
    }
  }

  // Handle dynamic content (AJAX loaded products)
  function observeProductGrids() {
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.hasAttribute && node.hasAttribute('data-hide-from-store')) {
                shouldCheck = true;
              }
              if (node.querySelector && node.querySelector('[data-hide-from-store="true"]')) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck) {
        hideProductsFromGrids();
      }
    });

    // Observe the main content area
    const mainContent = document.querySelector('[data-main], main, #MainContent');
    if (mainContent) {
      observer.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }

    // Specifically observe predictive search container
    const predictiveSearch = document.querySelector('predictive-search, [data-predictive-search-results], [data-search-results-wrapper]');
    if (predictiveSearch) {
      observer.observe(predictiveSearch, {
        childList: true,
        subtree: true
      });
    }

    // Also observe search popdown
    const searchPopdown = document.querySelector('[data-popdown-body], .search-popdown__results');
    if (searchPopdown) {
      observer.observe(searchPopdown, {
        childList: true,
        subtree: true
      });
    }
  }

  // Prevent clicks on hidden product links
  function preventHiddenProductClicks() {
    document.addEventListener('click', function(e) {
      // Do not redirect if in customizer
      if (isInCustomizer()) {
        return;
      }

      const link = e.target.closest('a[href*="/products/"]');
      if (link) {
        const productItem = link.closest('[data-hide-from-store="true"]');
        if (productItem) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = getShopAllUrl();
          return false;
        }
      }
    }, true); // Use capture phase to catch early
  }

  // Watch for predictive search updates
  function watchPredictiveSearch() {
    // Listen for input events on search inputs
    document.addEventListener('input', function(e) {
      if (e.target.matches('input[type="search"], input[name="q"]')) {
        // When user types in search, check after a delay
        setTimeout(hideProductsFromGrids, 100);
        setTimeout(hideProductsFromGrids, 300);
        setTimeout(hideProductsFromGrids, 500);
      }
    });

    // Watch for predictive search element changes
    const predictiveSearchElement = document.querySelector('predictive-search');
    if (predictiveSearchElement) {
      const searchObserver = new MutationObserver(function() {
        hideProductsFromGrids();
      });
      
      searchObserver.observe(predictiveSearchElement, {
        attributes: true,
        attributeFilter: ['results', 'open'],
        childList: true,
        subtree: true
      });
    }

    // Also watch the results wrapper
    const resultsWrapper = document.querySelector('[data-search-results-wrapper]');
    if (resultsWrapper) {
      const wrapperObserver = new MutationObserver(function() {
        hideProductsFromGrids();
      });
      
      wrapperObserver.observe(resultsWrapper, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialize on DOM ready
  function init() {
    // Hide products from grids
    hideProductsFromGrids();

    // Redirect from product page if needed
    redirectIfHidden();

    // Set up observer for dynamic content
    observeProductGrids();

    // Watch predictive search specifically
    watchPredictiveSearch();

    // Prevent clicks on hidden products
    preventHiddenProductClicks();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after a short delay to catch any late-loading content
  setTimeout(hideProductsFromGrids, 500);
  setTimeout(hideProductsFromGrids, 1000);
  setTimeout(hideProductsFromGrids, 2000);

  // More frequent checks for predictive search
  setInterval(function() {
    const predictiveSearch = document.querySelector('predictive-search[results="true"]');
    if (predictiveSearch) {
      hideProductsFromGrids();
    }
  }, 200);

  /**
   * Format money using Shopify format string
   */
  function formatMoney(cents, formatString) {
    if (!formatString) {
      // Fallback to simple format
      return '$' + (cents / 100).toFixed(2);
    }

    const placeholderRegex = /{{\s*(\w+)\s*}}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) {
        return '0';
      }

      const numString = (number / 100.0).toFixed(precision);
      const parts = numString.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    const value = formatWithDelimiters(cents, 2, ',', '.');
    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Update Add to Cart button with price
   * Can be called with retry option to handle delayed variant ID updates
   */
  function updateAddToCartButtonWithPrice(retryCount) {
    retryCount = retryCount || 0;
    // Find all add to cart buttons directly (more reliable)
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    
    if (addToCartButtons.length === 0) {
      return; // No buttons found
    }
    
    // Debug
    if (addToCartButtons.length > 0 && !window.priceUpdateLogged) {
      console.log('Updating', addToCartButtons.length, 'add to cart button(s) with prices...');
      window.priceUpdateLogged = true;
    }
    
    addToCartButtons.forEach(function(button) {
      const addToCartTextElement = button.querySelector('[data-add-to-cart-text]');
      if (!addToCartTextElement) {
        return;
      }
      
      // Find the product form - try multiple selectors
      let form = button.closest('form[data-product-form]');
      if (!form) {
        form = button.closest('form.product__form');
      }
      if (!form) {
        form = button.closest('form');
      }
      
      // Find product JSON - try multiple locations
      let productJson = null;
      if (form) {
        productJson = form.querySelector('[data-product-json]');
      }
      if (!productJson) {
        // Try finding by ID pattern
        const buttonId = button.id;
        if (buttonId) {
          const jsonId = buttonId.replace('AddToCart', 'ProductJson');
          productJson = document.getElementById(jsonId);
        }
      }
      if (!productJson) {
        // Try finding any product JSON script tag
        productJson = document.querySelector('script[data-product-json], script[id*="ProductJson"]');
      }
      
      if (!productJson) {
        // Debug: log if product JSON not found
        console.warn('Product JSON not found for button:', button.id);
        // Try to get price from the page's price display
        const priceElement = document.querySelector('[data-product-price], .product__price, .price');
        if (priceElement) {
          const priceText = priceElement.textContent.trim();
          const priceMatch = priceText.match(/[\$£€¥]?[\d,]+\.?\d*/);
          if (priceMatch) {
            const currentText = addToCartTextElement.textContent.trim();
            if (!currentText.includes(priceMatch[0])) {
              const addToCartText = typeof theme !== 'undefined' && theme.strings ? theme.strings.add_to_cart : 'Add to Cart';
              addToCartTextElement.textContent = addToCartText + ' - ' + priceMatch[0];
            }
          }
        }
        return;
      }
      
      try {
        const product = JSON.parse(productJson.textContent);
        if (!product || !product.variants) {
          console.warn('Product JSON invalid or no variants for button:', button.id);
          return;
        }
        
        // Find variant select - try multiple selectors
        // Note: variant ID is stored in a hidden input, not a checked radio
        let variantSelect = null;
        if (form) {
          variantSelect = form.querySelector('select[name="id"]');
          if (!variantSelect) {
            variantSelect = form.querySelector('input[name="id"]');
          }
        }
        if (!variantSelect) {
          // Try finding in the document
          variantSelect = document.querySelector('select[name="id"]');
          if (!variantSelect) {
            variantSelect = document.querySelector('input[name="id"]');
          }
        }
        
        if (!variantSelect) {
          // Use first available variant as fallback
          const firstAvailable = product.variants.find(function(v) { return v.available; });
          if (firstAvailable) {
            updateButtonWithVariant(addToCartTextElement, product, firstAvailable, form);
          }
          return;
        }
        
        const variantId = parseInt(variantSelect.value);
        if (!variantId || isNaN(variantId)) {
          // If variant ID is not set yet and we haven't retried too many times, retry
          if (retryCount < 3 && (variantSelect.value === '' || variantSelect.value === '0')) {
            setTimeout(function() {
              updateAddToCartButtonWithPrice(retryCount + 1);
            }, 200);
            return;
          }
          console.warn('Variant ID is invalid:', variantSelect.value);
          return;
        }
        
        const variant = product.variants.find(function(v) { return v.id === variantId; });
        
        if (!variant) {
          console.warn('Variant not found for ID:', variantId);
          return;
        }
        
        updateButtonWithVariant(addToCartTextElement, product, variant, form || null);
      } catch (e) {
        console.error('Error updating add to cart button price:', e);
        // Fallback: try to add price directly from variant
        try {
          if (variant && variant.available && variant.price !== undefined) {
            const fallbackPrice = ' - $' + (variant.price / 100).toFixed(2);
            const currentText = addToCartTextElement.textContent.trim();
            if (!currentText.includes('$') && !currentText.includes('Free')) {
              addToCartTextElement.textContent = currentText + fallbackPrice;
            }
          }
        } catch (e2) {
          console.error('Fallback price update also failed:', e2);
        }
      }
    });
  }
  
  /**
   * Get the current price including subscription plans (Skio)
   */
  function getCurrentPrice(variant, form) {
    // Check if there's a selected selling plan (subscription)
    let currentPrice = variant.price;
    
    if (form) {
      // Check for Skio selling plan input
      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      
      if (sellingPlanInput && sellingPlanInput.value) {
        const sellingPlanId = parseInt(sellingPlanInput.value);
        
        // Find the selling plan allocation for this variant
        if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
          const allocation = variant.selling_plan_allocations.find(function(alloc) {
            return alloc.selling_plan_id === sellingPlanId;
          });
          
          if (allocation) {
            // Use per_delivery_price if available, otherwise use price
            if (allocation.per_delivery_price !== undefined) {
              currentPrice = allocation.per_delivery_price;
            } else if (allocation.price !== undefined) {
              currentPrice = allocation.price;
            }
          }
        }
      }
    }
    
    return currentPrice;
  }

  /**
   * Update button text with variant price
   */
  function updateButtonWithVariant(element, product, variant, form) {
    // Get the current price (including subscription if selected)
    const currentPrice = getCurrentPrice(variant, form);
    
    // Get original price (compare_at_price) for sale display
    let originalPrice = null;
    if (variant.compare_at_price && variant.compare_at_price > currentPrice) {
      originalPrice = variant.compare_at_price;
    }
    
    // Format price - use theme object if available, otherwise use fallbacks
    let priceText = '';
    let originalPriceText = '';
    
    if (variant.available && currentPrice !== undefined && currentPrice !== null) {
      if (currentPrice === 0) {
        priceText = ' - ' + (typeof theme !== 'undefined' && theme.strings ? theme.strings.free : 'Free');
      } else {
        // Use Shopify's money formatting
        const currencyCodeEnable = typeof theme !== 'undefined' && theme.settings && theme.settings.currency_code_enable || false;
        if (currencyCodeEnable && typeof theme !== 'undefined' && theme.moneyWithCurrencyFormat) {
          priceText = ' - ' + formatMoney(currentPrice, theme.moneyWithCurrencyFormat);
          if (originalPrice) {
            originalPriceText = formatMoney(originalPrice, theme.moneyWithCurrencyFormat);
          }
        } else if (typeof theme !== 'undefined' && theme.moneyFormat) {
          priceText = ' - ' + formatMoney(currentPrice, theme.moneyFormat);
          if (originalPrice) {
            originalPriceText = formatMoney(originalPrice, theme.moneyFormat);
          }
        } else {
          // Fallback - always works
          priceText = ' - $' + (currentPrice / 100).toFixed(2);
          if (originalPrice) {
            originalPriceText = '$' + (originalPrice / 100).toFixed(2);
          }
        }
      }
    }
    
    // Debug if priceText is still empty
    if (!priceText && variant.available && variant.price !== undefined) {
      console.warn('Price text empty, using fallback. Variant price:', variant.price);
      priceText = ' - $' + (variant.price / 100).toFixed(2);
    }
    
    // Add original price with strikethrough if on sale
    if (originalPriceText) {
      priceText = priceText + ' <span style="text-decoration: line-through; opacity: 0.7; margin-left: 0.25em;">' + originalPriceText + '</span>';
    }
    
    // Update button text
    const currentText = element.textContent.trim();
    const currentInnerHTML = element.innerHTML.trim();
    
    // Only update if variant is available
    if (variant.available) {
      // Check if price is already in the text (more flexible regex)
      const hasPrice = currentText.match(/\s*-\s*[\$£€¥]?[\d,]+\.?\d*\s*/);
      const hasFree = currentText.match(/\s*-\s*Free\s*/i);
      
      // Always update to ensure price is correct
      let baseText = currentText;
      
      // Remove existing price if present (more aggressive removal)
      if (hasPrice) {
        // Remove price pattern from end of text
        baseText = baseText.replace(/\s*-\s*[\$£€¥]?[\d,]+\.?\d*\s*.*$/, '').trim();
      } else if (hasFree) {
        baseText = baseText.replace(/\s*-\s*Free\s*.*$/i, '').trim();
      }
      
      // Also check innerHTML for price spans
      if (currentInnerHTML.includes('<span') && currentInnerHTML.includes('line-through')) {
        // Remove HTML price spans
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = currentInnerHTML;
        const textNodes = [];
        for (let node of tempDiv.childNodes) {
          if (node.nodeType === 3) { // Text node
            textNodes.push(node.textContent);
          } else if (node.nodeType === 1 && !node.querySelector('span[style*="line-through"]')) {
            textNodes.push(node.textContent);
          }
        }
        baseText = textNodes.join('').trim();
        // Remove price pattern
        baseText = baseText.replace(/\s*-\s*[\$£€¥]?[\d,]+\.?\d*\s*.*$/, '').trim();
      }
      
      // Determine base text if it's just "Add to Cart" or similar
      const addToCartText = typeof theme !== 'undefined' && theme.strings ? theme.strings.add_to_cart : 'Add to Cart';
      const preorderText = typeof theme !== 'undefined' && theme.strings ? theme.strings.preorder : 'Preorder';
      
      if (baseText === addToCartText || baseText === preorderText) {
        // Use the base text as is
      } else if (baseText.includes(addToCartText)) {
        baseText = addToCartText;
      } else if (baseText.includes(preorderText)) {
        baseText = preorderText;
      }
      
      // Determine final text - ALWAYS add price if variant is available
      let newText = '';
      
      if (priceText) {
        // We have a formatted price
        if (product.tags && product.tags.includes('_preorder')) {
          newText = preorderText + priceText;
        } else {
          newText = (baseText || addToCartText) + priceText;
        }
      } else if (variant.price !== undefined && variant.price !== null) {
        // Fallback: format price directly if priceText is empty
        if (variant.price === 0) {
          newText = addToCartText + ' - ' + (typeof theme !== 'undefined' && theme.strings ? theme.strings.free : 'Free');
        } else {
          const fallbackPrice = ' - $' + (variant.price / 100).toFixed(2);
          let fallbackOriginalPrice = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            fallbackOriginalPrice = ' <span style="text-decoration: line-through; opacity: 0.7; margin-left: 0.25em;">$' + (variant.compare_at_price / 100).toFixed(2) + '</span>';
          }
          newText = (baseText || addToCartText) + fallbackPrice + fallbackOriginalPrice;
        }
      } else {
        // No price available, use current text
        newText = currentText;
      }
      
      // Always update to ensure price is there (compare both text and HTML)
      const needsUpdate = currentText !== newText && currentInnerHTML !== newText;
      if (needsUpdate || priceText) {
        // Use innerHTML if we have strikethrough price, otherwise use textContent
        if (newText.includes('<span')) {
          element.innerHTML = newText;
        } else {
          element.textContent = newText;
        }
      }
    }
  }

  // Update button when variant changes
  function initAddToCartPriceUpdate() {
    // Listen for variant selection changes
    document.addEventListener('change', function(e) {
      if (e.target.matches('select[name="id"], input[name="id"]') || 
          e.target.closest('[data-product-form]') ||
          e.target.closest('form')) {
        setTimeout(updateAddToCartButtonWithPrice, 100);
      }
    });
    
    // Listen for changes on option inputs (including swatches)
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-single-option-selector], input[name*="option"], select[name*="option"]')) {
        // Wait a bit longer for the theme to update the variant ID
        setTimeout(updateAddToCartButtonWithPrice, 300);
        // Also try again after a longer delay as fallback
        setTimeout(updateAddToCartButtonWithPrice, 500);
      }
    });
    
    // Also listen for clicks on variant options and swatches
    document.addEventListener('click', function(e) {
      // Check for radio option inputs
      if (e.target.matches('input[type="radio"][name*="option"], label[for*="option"]') ||
          e.target.closest('input[type="radio"][name*="option"]')) {
        // Wait for variant ID to update
        setTimeout(updateAddToCartButtonWithPrice, 300);
        setTimeout(updateAddToCartButtonWithPrice, 500);
      }
      // Check for swatch buttons and labels
      else if (e.target.matches('[data-swatches-button], .swatch__button, .swatch__label, [data-swatch]') ||
               e.target.closest('[data-swatches-button], .swatch__button, .swatch__label')) {
        // Wait for variant ID to update after swatch click
        setTimeout(updateAddToCartButtonWithPrice, 300);
        setTimeout(updateAddToCartButtonWithPrice, 500);
      }
    });
    
    // Listen for Skio subscription plan changes
    document.addEventListener('change', function(e) {
      // Check if it's a selling plan selection (Skio subscription)
      if (e.target.matches('input[name="selling_plan"], input[name="selling_plan_button"], input[type="radio"][name*="skio-group"], input[type="radio"][name*="selling_plan"]')) {
        setTimeout(updateAddToCartButtonWithPrice, 100);
      }
    });
    
    // Also listen for clicks on Skio plan options
    document.addEventListener('click', function(e) {
      if (e.target.closest('skio-plan-picker') || 
          e.target.closest('[name*="skio-group"]') ||
          e.target.closest('[name*="selling_plan"]')) {
        setTimeout(updateAddToCartButtonWithPrice, 150);
      }
    });

    // Listen for custom events that might indicate variant changes
    document.addEventListener('variant:change', function() {
      setTimeout(updateAddToCartButtonWithPrice, 100);
    });
    document.addEventListener('theme:variant:change', function() {
      setTimeout(updateAddToCartButtonWithPrice, 100);
    });
    
    // Directly observe variant ID input changes (more reliable)
    // Use a WeakSet to track which inputs already have listeners to avoid duplicates
    const variantInputsWithListeners = new WeakSet();
    
    function observeVariantInputs() {
      const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
      variantInputs.forEach(function(input) {
        if (!variantInputsWithListeners.has(input)) {
          variantInputsWithListeners.add(input);
          
          // Listen for change events
          input.addEventListener('change', function() {
            setTimeout(updateAddToCartButtonWithPrice, 100);
          });
          
          // Also listen for input events (fires when value changes, even programmatically)
          input.addEventListener('input', function() {
            setTimeout(updateAddToCartButtonWithPrice, 100);
          });
        }
      });
    }
    
    // Run immediately and also set up observer for dynamically added inputs
    observeVariantInputs();
    const variantObserver = new MutationObserver(function() {
      observeVariantInputs();
    });
    variantObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Use MutationObserver to watch for button text changes (when theme updates it)
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          if (target.hasAttribute && target.hasAttribute('data-add-to-cart-text')) {
            shouldUpdate = true;
          } else if (target.closest && target.closest('[data-add-to-cart-text]')) {
            shouldUpdate = true;
          }
        }
      });
      if (shouldUpdate) {
        setTimeout(updateAddToCartButtonWithPrice, 100);
      }
    });

    // Observe all add to cart text elements and their parents
    document.querySelectorAll('[data-add-to-cart-text]').forEach(function(element) {
      observer.observe(element, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });

    // Also observe the document body for dynamically added buttons
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial update - always run to ensure price is added
    setTimeout(function() {
      updateAddToCartButtonWithPrice();
      // Debug: log if buttons were found
      const buttons = document.querySelectorAll('[data-add-to-cart]');
      if (buttons.length > 0) {
        console.log('Found', buttons.length, 'add to cart button(s), updating prices...');
      }
    }, 500);
    setTimeout(updateAddToCartButtonWithPrice, 1000);
    setTimeout(updateAddToCartButtonWithPrice, 2000);
    setTimeout(updateAddToCartButtonWithPrice, 3000);
    
    // Continuous check to ensure price stays on button
    setInterval(function() {
      const buttons = document.querySelectorAll('[data-add-to-cart]');
      buttons.forEach(function(btn) {
        const textEl = btn.querySelector('[data-add-to-cart-text]');
        if (textEl) {
          const text = textEl.textContent.trim();
          // If button says "Add to Cart" without price, update it
          if (text === 'Add to Cart' || text === (typeof theme !== 'undefined' && theme.strings ? theme.strings.add_to_cart : 'Add to Cart')) {
            updateAddToCartButtonWithPrice();
          }
        }
      });
    }, 1000);
  }

  // Initialize price update on DOM ready
  // Wait for theme object to be available
  function waitForThemeAndInit() {
    if (typeof theme !== 'undefined' && theme.strings && theme.moneyFormat) {
      initAddToCartPriceUpdate();
    } else {
      // Retry after a short delay
      setTimeout(waitForThemeAndInit, 100);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForThemeAndInit);
  } else {
    waitForThemeAndInit();
  }
  
  // Also try after window load as fallback
  window.addEventListener('load', function() {
    setTimeout(function() {
      if (typeof theme !== 'undefined') {
        updateAddToCartButtonWithPrice();
      }
    }, 500);
  });

})();
